export const translations = {
  'guest-form.emailLegalText':
    'Your email will be used to provide digital receipts, account communications, and marketing messages from both Toast and restaurants you visit unless you unsubscribe.'
}
